import React, { useContext, useEffect, useState, useRef } from "react";
import "../../styles/expertDetails.css";
import Swal from "sweetalert2";
import { UrlContext } from "../../contexts/UrlContext";
import ModifyExperience from "../../components/EphProfile/ModifyExperience";
import AddExperience from "../../components/EphProfile/AddExperience";
import Skills from "../../components/EphProfile/Skills";
import Industries from "../../components/EphProfile/Industries";
import Note from "../../components/EphProfile/Note";
import { AddCertificate } from "../../components/EphProfile/AddCertificate";
import { ModifyCertificate } from "../../components/EphProfile/ModifyCertificate";
import { AddEducation } from "../../components/EphProfile/AddEducation";
import { ModifyEducation } from "../../components/EphProfile/ModifyEducation";
import { AddAward } from "../../components/EphProfile/AddAward";
import { ModifyAward } from "../../components/EphProfile/ModifyAward";
import { Contact } from "../../components/EphProfile/Contact";
import { Rates } from "../../components/EphProfile/Rates";
import { Info } from "../../components/EphProfile/Info";
import { Availability } from "../../components/EphProfile/Availability";
import ExpertSimilar from "../../components/EphProfile/ExpertSimilar";
import ExpertProjectInfo from "../../components/EphProfile/ExpertProjectInfo";
import { motion, AnimatePresence } from "framer-motion";
import industryLogo from "../../images/default_industry.png";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { use } from "react";
import { set } from "date-fns";
import { se } from "date-fns/locale";
import { get } from "jquery";

export default function ProfilePage({
  expertID,
  experienceData,
  setExperienceData,
  setHasExperince,
  setHasSkill,
  setHasIndustry,
  setHasLanguage,
  showStickyHeader,
}) {
  const { API_URL } = useContext(UrlContext);
  const id = expertID;
  const [dataSummary, setDataSummary] = useState("");
  const [count, setCount] = useState(0);
  const [email, setEmail] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [hourlyRate, setHourlyRate] = useState(null);
  const [dailyRate, setDailyRate] = useState(null);
  const [hourlyCurrency, setHourlyCurrency] = useState(null);
  const [dailyCurrency, setDailyCurrency] = useState(null);
  const [languages, setLanguages] = useState([]);
  const [languageChanged, setLanguageChanged] = useState(false);
  const [city, setCity] = useState(null);
  const [region, setRegion] = useState(null);
  const [country, setCountry] = useState(null);
  const [certificationData, setCertificationData] = useState([]);
  const [awardData, setAwardData] = useState([]);
  const [selectedExperience, setSelectedExperience] = useState(null);
  const [isModify, setIsModify] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTooLong, setIsTooLong] = useState(dataSummary.length > 400);
  const [isEditing, setIsEditing] = useState(false);
  const editableRef = useRef(null);
  const [isModifyEducation, setIsModifyEducation] = useState(false);
  const [isNewEducation, setIsNewEducation] = useState(false);
  const [selectedEducation, setSelectedEducation] = useState(null);
  const [educationArray, setEducationArray] = useState([]);
  const [isModifyCertification, setIsModifyCertification] = useState(false);
  const [isNewCertification, setIsNewCertification] = useState(false);
  const [selectedCertification, setSelectedCertification] = useState(null);
  const [isModifyAward, setIsModifyAward] = useState(false);
  const [isNewAward, setIsNewAward] = useState(false);
  const [selectedAward, setSelectedAward] = useState(null);
  const [firstContactLog, setFirstContactLog] = useState(null);
  const [availability, setAvailability] = useState(null);
  const [availabilityComment, setAvailabilityComment] = useState(
    "No availability comment"
  );
  const [loading, setLoading] = useState(false);
  const [expertData, setExpertData] = useState({});
  const [isDragging, setIsDragging] = useState(false);
  const clickTimeout = useRef(null);
  const dragStartRef = useRef(false);
  let currentController = null;

  // useEffect(() => {
  //   setEmail(data.email);
  //   setPhoneNumber(data.phone_n);
  //   setHourlyRate(data.hourly_rate);
  //   setDailyRate(data.daily_rate);
  //   setHourlyCurrency(data.hourly_rate_currency);
  //   setDailyCurrency(data.daily_rate_currency);
  //   setCity(data.city);
  //   setRegion(data.region);
  //   setCountry(data.country);
  //   setAvailability(data.Available_from);
  //   setAvailabilityComment(data.Available_comment || 'No availability comment');
  // }, [data]);

  // Fetch expert data
  useEffect(() => {
    const fetchExpert = async () => {
      setLoading(true);
      const tokenObj = localStorage.getItem("eph-token");
      const token =
        JSON.parse(tokenObj)?.value || localStorage.getItem("AccessToken");
      const url = `${API_URL}expert-details/${id}`;

      try {
        const res = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        const data = await res.json();
        const expert = data.expert;

        setExpertData(expert);
        setEmail(expert.email);
        setPhoneNumber(expert.phone_n);
        setHourlyRate(expert.hourly_rate);
        setDailyRate(expert.daily_rate);
        setHourlyCurrency(expert.hourly_rate_currency);
        setDailyCurrency(expert.daily_rate_currency);
        setCity(expert.city);
        setRegion(expert.region);
        setCountry(expert.country);
        setAvailability(expert.Available_from);
        setAvailabilityComment(
          expert.Available_comment || "No availability comment"
        );
        if (expert?.summ) {
          setDataSummary(expert.summ);
          setIsTooLong(expert.summ.length > 400);
        }
        if (expert?.education) {
          const months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ];
          const educationArray = expert?.education
            .split("\n\n")
            .filter((e) => e.trim() !== "")
            .sort((a, b) => {
              const aLines = a.split("\n");
              const bLines = b.split("\n");

              const aDate = aLines[2]?.split(" - ")[1];
              const bDate = bLines[2]?.split(" - ")[1];

              if (aDate === "Present" && bDate !== "Present") return -1;
              if (bDate === "Present" && aDate !== "Present") return 1;

              if (aDate && bDate) {
                const [aMonth, aYear] = aDate.split(" ");
                const [bMonth, bYear] = bDate.split(" ");
                const monthIndex = (m) => months.indexOf(m);
                const aVal = new Date(Number(aYear), monthIndex(aMonth));
                const bVal = new Date(Number(bYear), monthIndex(bMonth));
                return bVal - aVal;
              }
              return 0;
            });
          setEducationArray(educationArray);
        }
      } catch (err) {
        console.error("Network or unexpected error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchExpert();
    getExpertExperience();
  }, []);

  // API to get expert experinece data
  const getExpertExperience = async () => {
    const tokenObj = localStorage.getItem("eph-token");
    const token =
      JSON.parse(tokenObj).value || localStorage.getItem("AccessToken");
    const requestBody = {
      expertID: id,
    };
    try {
      let modifiedUrl = "fetch-expert-experience";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const responseData = await response.json();
      if (responseData.status === "success") {
        setExperienceData(responseData.expertExperience);
        setHasExperince(true);
      } else if (responseData.status === "error") {
        console.error("Error fetching expert experience:", responseData.text);
      } else {
        console.error("Error fetching expert experience:", responseData.text);
      }
    } catch (error) {
      console.error("Network or unexpected error:", error);
    }
  };

  const getLanguages = async () => {
    const tokenObj = localStorage.getItem("eph-token");
    const token =
      JSON.parse(tokenObj).value || localStorage.getItem("AccessToken");
    const requestBody = {
      expertID: id,
    };
    try {
      let modifiedUrl = "get-profile-language";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setLanguages(responseData.languages);
        if (responseData.languages.length > 0) {
          setHasLanguage(true);
        }
      } else {
        console.error("Failed to get language");
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
    }
  };

  useEffect(() => {
    getLanguages();
  }, [languageChanged]);

  const deleteLanguage = async (language) => {
    const tokenObj = localStorage.getItem("eph-token");
    const token =
      JSON.parse(tokenObj).value || localStorage.getItem("AccessToken");
    const requestBody = {
      expertID: id,
      ...language,
    };
    try {
      let modifiedUrl = "delete-expert-language";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setLanguageChanged(!languageChanged);
      } else {
        console.error("Failed to get language");
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
    }
  };

  // useEffect(() => {
  //   if (data?.summ) {
  //     setDataSummary(data.summ);
  //     setIsTooLong(data.summ.length > 400);
  //   }
  //   if (data?.education) {
  //     const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  //     const educationArray = data?.education
  //       .split("\n\n")
  //       .filter((e) => e.trim() !== "")
  //       .sort((a, b) => {
  //         const aLines = a.split("\n");
  //         const bLines = b.split("\n");

  //         const aDate = aLines[2]?.split(" - ")[1];
  //         const bDate = bLines[2]?.split(" - ")[1];

  //         if (aDate === "Present" && bDate !== "Present") return -1;
  //         if (bDate === "Present" && aDate !== "Present") return 1;

  //         if (aDate && bDate) {
  //           const [aMonth, aYear] = aDate.split(" ");
  //           const [bMonth, bYear] = bDate.split(" ");
  //           const monthIndex = (m) => months.indexOf(m);
  //           const aVal = new Date(Number(aYear), monthIndex(aMonth));
  //           const bVal = new Date(Number(bYear), monthIndex(bMonth));
  //           return bVal - aVal;
  //         }
  //         return 0;
  //       });
  //     setEducationArray(educationArray);
  //   }
  // }, [data]);

  useEffect(() => {
    if (isEditing && editableRef.current) {
      editableRef.current.focus();
      // Move cursor to the end
      document.execCommand("selectAll", false, null);
      document.getSelection().collapseToEnd();
    }
  }, [isEditing]);

  // Optional: to restart animation on re-edit
  useEffect(() => {
    if (isEditing) {
      const container = document.querySelector(".glow-burst");
      if (container) {
        container.classList.remove("glow-burst");
        void container.offsetWidth; // Trigger reflow
        container.classList.add("glow-burst");
      }
    }
  }, [isEditing]);

  const handleSummaryChange = () => {
    const tokenObj = localStorage.getItem("eph-token");
    const token =
      JSON.parse(tokenObj).value || localStorage.getItem("AccessToken");
    const updatedSummary = editableRef.current.innerText;
    const url = `${API_URL}update-expert-summary/` + id;
    fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ summary: updatedSummary }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          Swal.fire({
            icon: "success",
            title: "Summary updated successfully",
            showConfirmButton: false,
            timer: 1500,
          });

          setDataSummary(updatedSummary);
          setIsTooLong(updatedSummary.length > 400);
          setIsExpanded(false);
          setIsEditing(false);
          setCount(count + 1);
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            onfirmButtonColor: "#365565",
          });
        }
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          onfirmButtonColor: "#365565",
        });
      });
  };

  const handleCancelSummary = () => {
    setIsEditing(false);
    setIsExpanded(false);
    if (editableRef.current) {
      editableRef.current.innerText = dataSummary;
    }
  };

  // API to get expert certifications data
  const getExpertCertifications = async () => {
    const tokenObj = localStorage.getItem("eph-token");
    const token =
      JSON.parse(tokenObj).value || localStorage.getItem("AccessToken");
    const requestBody = {
      expertID: id,
    };
    try {
      let modifiedUrl = "fetch-expert-certifications";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const responseData = await response.json();
      if (responseData.status === "success") {
        setCertificationData(responseData.expertCertification);
      } else if (responseData.status === "error") {
        Swal.fire({
          title: "Error!",
          text: responseData.text,
          icon: "error",
          confirmButtonText: "OK",
          onfirmButtonColor: "#365565",
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: "Failed to fetch expert experience",
          icon: "error",
          confirmButtonText: "OK",
          onfirmButtonColor: "#365565",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  // API to get expert awards data
  const getExpertAwards = async () => {
    const tokenObj = localStorage.getItem("eph-token");
    const token =
      JSON.parse(tokenObj).value || localStorage.getItem("AccessToken");
    const requestBody = {
      expertID: id,
    };
    try {
      let modifiedUrl = "fetch-expert-awards";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const responseData = await response.json();
      if (responseData.status === "success") {
        setAwardData(responseData.expertAwards);
      } else if (responseData.status === "error") {
        Swal.fire({
          title: "Error!",
          text: responseData.text,
          icon: "error",
          confirmButtonText: "OK",
          onfirmButtonColor: "#365565",
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: "Failed to fetch expert experience",
          icon: "error",
          confirmButtonText: "OK",
          onfirmButtonColor: "#365565",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error,
        icon: "error",
        confirmButtonText: "OK",
        onfirmButtonColor: "#365565",
      });
    }
  };

  // Api call to get the first contact log
  const fetchFirstContactLog = () => {
    const tokenObj = localStorage.getItem("eph-token");
    const token =
      JSON.parse(tokenObj).value || localStorage.getItem("AccessToken");
    const url = `${API_URL}get-expert-contact-log`;
    const data = {
      expertID: id,
    };
    fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          if (data.contactLog !== null) {
            setFirstContactLog(data.contactLog);
          }
        } else {
          console.log("No contact log found");
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getExpertCertifications();
    getExpertAwards();
    fetchFirstContactLog();
  }, [id]);

  // API to save expert education data
  const saveEducationData = async (educationString) => {
    const tokenObj = localStorage.getItem("eph-token");
    const token =
      JSON.parse(tokenObj).value || localStorage.getItem("AccessToken");
    try {
      const response = await fetch(`${API_URL}save-eph-education-data`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          expertID: id,
          education: educationString, // sending the formatted education string
        }),
      });

      const result = await response.json();

      if (result.status === "success") {
        Swal.fire({
          title: "Saved!",
          text: "Your education data has been saved.",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        Swal.fire({
          title: "Error",
          text: result.text || "Something went wrong.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error.message,
        icon: "error",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  // Api for save contact data
  const saveContactData = async (contactInfo) => {
    const tokenObj = localStorage.getItem("eph-token");
    const token =
      JSON.parse(tokenObj).value || localStorage.getItem("AccessToken");
    try {
      const response = await fetch(`${API_URL}save-eph-contact-data`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          expertID: id,
          ...contactInfo,
        }),
      });

      const result = await response.json();

      if (result.status === "success") {
        setEmail(contactInfo.email);
        setPhoneNumber(contactInfo.phoneNumber);
        Swal.fire({
          title: "Saved!",
          text: "Your contact data has been saved.",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        Swal.fire({
          title: "Error",
          text: result.text || "Something went wrong.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error.message,
        icon: "error",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  // Api for saving rate data
  const saveRateData = async (rates) => {
    const tokenObj = localStorage.getItem("eph-token");
    const token =
      JSON.parse(tokenObj).value || localStorage.getItem("AccessToken");
    try {
      const response = await fetch(`${API_URL}save-eph-rates-data`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          expertID: id,
          ...rates,
        }),
      });

      const result = await response.json();

      if (result.status === "success") {
        setDailyRate(rates.dailyRate);
        setDailyCurrency(rates.dailyCurrency);
        setHourlyRate(rates.hourlyRate);
        setHourlyCurrency(rates.hourlyCurrency);
        Swal.fire({
          title: "Saved!",
          text: "Your rates has been saved.",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        Swal.fire({
          title: "Error",
          text: result.text || "Something went wrong.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error.message,
        icon: "error",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  // Api for saving rate data
  const saveAvailabilityData = async (expAvl) => {
    const tokenObj = localStorage.getItem("eph-token");
    const token =
      JSON.parse(tokenObj).value || localStorage.getItem("AccessToken");
    try {
      const response = await fetch(`${API_URL}save-eph-availability-data`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          expertID: id,
          ...expAvl,
        }),
      });

      const result = await response.json();

      if (result.status === "success") {
        setAvailability(expAvl.availability);
        setAvailabilityComment(expAvl.availabilityComment);
        Swal.fire({
          title: "Saved!",
          text: "Your availability has been saved.",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        Swal.fire({
          title: "Error",
          text: result.text || "Something went wrong.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error.message,
        icon: "error",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  // Api for saving rate data
  const saveInfoData = async (info) => {
    const tokenObj = localStorage.getItem("eph-token");
    const token =
      JSON.parse(tokenObj).value || localStorage.getItem("AccessToken");
    try {
      const response = await fetch(`${API_URL}save-eph-info-data`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          expertID: id,
          ...info,
        }),
      });

      const result = await response.json();

      if (result.status === "success") {
        setLanguageChanged(!languageChanged);
        setCity(info.city);
        setRegion(info.region);
        setCountry(info.country);
        Swal.fire({
          title: "Saved!",
          text: "Your info has been saved.",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        Swal.fire({
          title: "Error",
          text: result.text || "Something went wrong.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error.message,
        icon: "error",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  // API for saving re-arranged experience blocks
  const handleDragEnd = async (result) => {
    if (currentController) currentController.abort();
    currentController = new AbortController();

    setIsDragging(false);
    dragStartRef.current = false;
    if (!result.destination) return;

    const items = Array.from(experienceData);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setExperienceData(items);

    const newOrder = items.map((exp) => exp.experienceID);
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;

    try {
      await fetch(`${API_URL}reorder-expert-experience`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ expertID: id, order: newOrder }),
        signal: currentController.signal,
      });
    } catch (err) {
      if (err.name !== "AbortError") console.error("Reorder failed:", err);
    }
  };

  return (
    <>
      {loading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-white/30 rounded-xl">
          <svg
            className="animate-spin h-20 w-20 text-gray-600"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="#365561"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="#365561"
              d="M4 12a8 8 0 018-8v8z"
            />
          </svg>
        </div>
      )}
      <section className="col-span-2 space-y-6">
        {/* Summary */}
        <div
          className={`bg-white rounded-xl p-6 relative transition-all duration-300 ${
            isEditing ? "glow-burst glow-hold" : "shadow"
          }`}
        >
          <div className="flex justify-between items-center mb-2">
            <h2 className="text-xl font-bold">About</h2>
            {!isEditing ? (
              <button
                className="absolute top-5.5 right-6 text-gray-500 hover:text-black hover:bg-gray-200 focus:outline-none py-1 px-2 rounded-full transition"
                onClick={() => {
                  setIsEditing(true);
                  if (isTooLong) setIsExpanded(true);
                }}
              >
                <i className="fa-solid fa-pencil" />
              </button>
            ) : (
              <div className="absolute top-5.5 right-6 flex gap-2">
                <button
                  className="text-gray-500 hover:text-black focus:outline-none py-1 px-2.5 rounded-full hover:bg-gray-200 transition"
                  onClick={handleSummaryChange}
                  title="Save"
                >
                  <i className="fa-solid fa-floppy-disk" />
                </button>
                <button
                  className="text-gray-500 hover:text-black focus:outline-none py-1 px-2.5 rounded-full hover:bg-gray-200 transition"
                  onClick={handleCancelSummary}
                  title="Cancel"
                >
                  <i className="fa-solid fa-xmark" />
                </button>
              </div>
            )}
          </div>
          <AnimatePresence initial={false} mode="wait">
            <motion.div
              key={isEditing ? "edit" : isExpanded ? "full" : "truncated"}
              className="overflow-hidden"
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.3 }}
            >
              {!isEditing ? (
                <p className="text-gray-800 whitespace-pre-line text-sm">
                  {dataSummary === "No Summary Available"
                    ? dataSummary
                    : isExpanded
                    ? dataSummary
                    : dataSummary.length > 400
                    ? `${dataSummary.substring(0, 400)}...`
                    : dataSummary}
                </p>
              ) : (
                <div
                  ref={editableRef}
                  contentEditable
                  suppressContentEditableWarning
                  className="text-sm text-gray-800 whitespace-pre-wrap p-3 rounded border border-gray-200 focus:outline-none"
                >
                  {dataSummary}
                </div>
              )}
            </motion.div>
          </AnimatePresence>
          {!isEditing && isTooLong && (
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="mt-2 text-blue-600 text-sm focus:outline-none hover:underline transition"
            >
              {isExpanded ? "See Less" : "See More"}
            </button>
          )}
          {/* Glowing box-shadow animation */}
          <style>
            {`
              @keyframes glowBurst {
                0% {
                  box-shadow: 0 0 0px 0px rgba(54, 85, 97, 0);
                }
                30% {
                  box-shadow: 0 0 20px 6px rgba(54, 85, 97, 0.6);
                }
                100% {
                  box-shadow: 0 0 15px 3px rgba(54, 85, 97, 0.6);
                }
              }

              .glow-burst {
                animation: glowBurst 0.8s ease-out forwards;
                border-radius: 0.75rem;
              }

              .glow-hold {
                box-shadow: 0 0 20px 6px rgba(54, 85, 97, 0.6);
                border-radius: 0.75rem;
              }
            `}
          </style>
        </div>

        {/* Experience */}
        <AnimatePresence mode="wait">
          {!isModify ? (
            // View existing experience blocks
            <motion.div
              key="experience-view"
              layout={false}
              initial={{ x: 0, opacity: 1 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: "100%", opacity: 0 }}
              transition={{ type: "spring", stiffness: 500, damping: 30 }}
              className="bg-white rounded-xl shadow p-6 relative"
            >
              <h2 className="text-xl font-bold mb-6">Experience</h2>
              <button
                className="absolute top-6 right-6 text-gray-500 hover:text-black hover:bg-gray-200 focus:outline-none pt-0.5 pb-0.5 pl-2 pr-2 rounded-full transition"
                onClick={() => {
                  setSelectedExperience(null);
                  setIsModify(true);
                  setIsNew(true);
                }}
              >
                <i className="fa-solid fa-plus text-lg"></i>
              </button>

              {experienceData?.length > 0 ? (
                <DragDropContext
                  onDragStart={() => {
                    setIsDragging(true);
                    dragStartRef.current = true;
                    clearTimeout(clickTimeout.current);
                  }}
                  onDragEnd={handleDragEnd}
                >
                  <Droppable droppableId="experience-list">
                    {(provided) => (
                      <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        className="space-y-2"
                      >
                        {experienceData.map((exp, index) => (
                          <Draggable
                            key={exp.id || index}
                            draggableId={exp.id?.toString() || `exp-${index}`}
                            index={index}
                          >
                            {(provided, snapshot) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps} // drag from anywhere
                                className={`relative rounded-md transition duration-200 px-2 py-1 select-none ${
                                  snapshot.isDragging
                                    ? "bg-gray-200 shadow-md cursor-grabbing"
                                    : "cursor-grab hover:bg-gray-100"
                                }`}
                                onMouseDown={() => {
                                  // Slight delay to differentiate click vs drag
                                  clickTimeout.current = setTimeout(() => {
                                    dragStartRef.current = true;
                                  }, 120);
                                }}
                                onMouseUp={(e) => {
                                  clearTimeout(clickTimeout.current);
                                  if (!dragStartRef.current && !snapshot.isDragging) {
                                    // It's a click, not a drag
                                    setSelectedExperience(exp);
                                    setIsModify(true);
                                  }
                                  dragStartRef.current = false;
                                }}
                              >
                                {exp.subExperienceBlocks?.length > 0 ? (
                                  <>
                                    <div className="flex ml-1 items-start gap-4">
                                      {exp.companyLogo ? (
                                        <img
                                          src={
                                            exp.companyLogo.includes("/pictures/")
                                              ? `https://images.expertpowerhouse.com${exp.companyLogo}`
                                              : exp.companyLogo
                                          }
                                          alt="Company Logo"
                                          onError={(e) => {
                                            e.target.onerror = null; // Prevent infinite loop
                                            e.target.src = industryLogo;
                                          }}
                                          className="w-10 h-10 sm:w-12 sm:h-12 rounded-full object-contain border"
                                        />
                                      ) : (
                                        <img
                                          src={industryLogo}
                                          alt="Default Industry Logo"
                                          className="w-10 h-10 sm:w-12 sm:h-12 rounded-full object-contain border bg-gray-100"
                                        />
                                      )}
                                      <div>
                                        <h3 className="font-semibold text-gray-900 text-sm sm:text-base">
                                          {exp.companyName}
                                        </h3>
                                        <p className="text-sm text-gray-500">
                                          {exp.duration}
                                        </p>
                                      </div>
                                    </div>
                                    <ul className="list-none mt-2 ml-9 pl-4 relative">
                                      {exp.subExperienceBlocks.map((role, j) => (
                                        <li key={j} className={`relative pl-2 ${j === exp.subExperienceBlocks.length - 1 ? "" : "mb-3"}`}>
                                          <div className="absolute -left-[35px] top-2 w-2 h-2 bg-gray-400 rounded-full z-10"></div>
                                          {j !== exp.subExperienceBlocks.length - 1 && (
                                            <div className="absolute -left-[32px] top-5 h-full w-px bg-gray-300 z-0"></div>
                                          )}
                                          <h4 className="text-gray-800 font-medium text-sm sm:text-base">
                                            {role.designation}
                                          </h4>
                                          <p className="text-xs text-gray-500">
                                            {role.joiningDate}{" "}
                                            {role.leavingDate ? "-" : null}{" "}
                                            {role.leavingDate}{" "}
                                            {role.duration ? "." : null} {role.duration}
                                          </p>

                                          {/* Extra fields for future detailed experience section like LinkedIn */}
                                          {role.location && (
                                            <p className="text-xs text-gray-500">
                                              {role.location}
                                            </p>
                                          )}
                                          {role.description && (
                                            <p className="mt-1 text-sm text-gray-700 whitespace-pre-line">
                                              {role.description}
                                            </p>
                                          )}
                                          {role.skills && (
                                            <p className="mt-2 text-xs text-gray-600 font-medium">
                                              💡 {role.skills.join(", ")}
                                            </p>
                                          )}
                                        </li>
                                      ))}
                                    </ul>
                                  </>
                                ) : (
                                  <div className="ml-1 flex gap-4">
                                    {exp.companyLogo ? (
                                      <img
                                        src={
                                          exp.companyLogo.includes("/pictures/")
                                            ? `https://images.expertpowerhouse.com${exp.companyLogo}`
                                            : exp.companyLogo
                                        }
                                        alt="Company Logo"
                                        onError={(e) => {
                                          e.target.onerror = null; // Prevent infinite loop
                                          e.target.src = industryLogo;
                                        }}
                                        className="w-10 h-10 sm:w-12 sm:h-12 rounded-full object-contain border"
                                      />
                                    ) : (
                                      <img
                                        src={industryLogo}
                                        alt="Default Industry Logo"
                                        className="w-10 h-10 sm:w-12 sm:h-12 rounded-full object-contain border bg-gray-100"
                                      />
                                    )}
                                    <div>
                                      <h4 className="text-gray-800 font-medium text-sm sm:text-base">
                                        {exp.designation}
                                      </h4>
                                      <p className="text-sm text-gray-500">
                                        {exp.companyName}
                                      </p>
                                      <p className="text-xs text-gray-500">
                                        {exp.joiningDate} {exp.leavingDate ? "-" : null}{" "}
                                        {exp.leavingDate} {exp.duration ? "·" : null}{" "}
                                        {exp.duration}
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              ) : (
                <p className="text-sm text-gray-500">
                  No experience data available.
                </p>
              )}
            </motion.div>
          ) : isNew ? (
            <motion.div
              key="add-view"
              initial={{ x: "-100%", opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: "-100%", opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="bg-white rounded-xl shadow p-6 relative"
            >
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold">Add New Experience</h2>
                <button
                  className="text-gray-500 hover:text-black hover:bg-gray-200 focus:outline-none pt-0.5 pb-0.5 pl-2 pr-2 rounded-full transition"
                  onClick={() => {
                    setSelectedExperience(null);
                    setIsModify(false);
                    setIsNew(false);
                  }}
                >
                  <i className="fa-solid fa-xmark text-lg"></i>
                </button>
              </div>
              <AddExperience
                expertID={id}
                getExpertExperience={getExpertExperience}
                setIsNew={setIsNew}
                setIsModify={setIsModify}
                setSelectedExperience={setSelectedExperience}
                clickedFrom="profile"
              />
            </motion.div>
          ) : (
            <motion.div
              key="modify-view"
              initial={{ x: "-100%", opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: "-100%", opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="bg-white rounded-xl shadow p-6 relative"
            >
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold">Modify Experience</h2>
                <button
                  className="text-gray-500 hover:text-black hover:bg-gray-200 focus:outline-none pt-0.5 pb-0.5 pl-2 pr-2 rounded-full transition"
                  onClick={() => setIsModify(false)}
                >
                  <i className="fa-solid fa-xmark text-lg"></i>
                </button>
              </div>
              <ModifyExperience
                experience={selectedExperience}
                getExpertExperience={getExpertExperience}
                setIsModify={setIsModify}
                clickedFrom="profile"
              />
            </motion.div>
          )}
        </AnimatePresence>

        {/* Education */}
        <AnimatePresence mode="wait">
          {!isModifyEducation ? (
            <motion.div
              key="education-view"
              initial={{ x: 0, opacity: 1 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: "100%", opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="bg-white rounded-xl shadow p-6 relative"
            >
              <h2 className="text-xl font-bold mb-6">Education</h2>
              <button
                className="absolute top-6 right-6 text-gray-500 hover:text-black hover:bg-gray-200 focus:outline-none pt-0.5 pb-0.5 pl-2 pr-2 rounded-full transition"
                onClick={() => {
                  setSelectedEducation(null);
                  setIsModifyEducation(true);
                  setIsNewEducation(true);
                }}
              >
                <i className="fa-solid fa-plus text-lg"></i>
              </button>
              {educationArray.length > 0 ? (
                <ul className="list-none space-y-0">
                  {educationArray.map((item, index) => {
                    const lines = item.split("\n");
                    return (
                      <li
                        key={index}
                        className="pl-1 cursor-pointer hover:bg-gray-100 p-2 rounded-md transition duration-200"
                        onClick={() => {
                          setSelectedEducation(item);
                          setIsModifyEducation(true);
                          setIsNewEducation(false);
                        }}
                      >
                        <p className="text-m font-medium text-gray-800">
                          {lines[0]}
                        </p>
                        {lines[1] && (
                          <p className="text-sm text-gray-600">{lines[1]}</p>
                        )}
                        {lines[2] && (
                          <p className="text-sm text-gray-500">{lines[2]}</p>
                        )}
                      </li>
                    );
                  })}
                </ul>
              ) : (
                <p className="text-sm text-gray-500">
                  No education data available.
                </p>
              )}
            </motion.div>
          ) : isNewEducation ? (
            <motion.div
              key="add-education"
              initial={{ x: "-100%", opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: "-100%", opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="bg-white rounded-xl shadow p-6 relative"
            >
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold">Add New Education</h2>
                <button
                  className="text-gray-500 hover:text-black hover:bg-gray-200 focus:outline-none pt-0.5 pb-0.5 pl-2 pr-2 rounded-full transition"
                  onClick={() => {
                    setSelectedEducation(null);
                    setIsModifyEducation(false);
                    setIsNewEducation(false);
                  }}
                >
                  <i className="fa-solid fa-xmark text-lg"></i>
                </button>
              </div>
              {/* AddEducation component here */}
              <AddEducation
                saveEducationData={saveEducationData}
                fullEducationData={
                  educationArray.length > 0 ? educationArray.join("\n\n") : null
                }
                setEducationArray={setEducationArray}
                onCancel={() => {
                  setIsModifyEducation(false);
                  setIsNewEducation(false);
                }}
              />
            </motion.div>
          ) : (
            <motion.div
              key="modify-education"
              initial={{ x: "-100%", opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: "-100%", opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="bg-white rounded-xl shadow p-6 relative"
            >
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold">Modify Education</h2>
                <button
                  className="text-gray-500 hover:text-black hover:bg-gray-200 focus:outline-none pt-0.5 pb-0.5 pl-2 pr-2 rounded-full transition"
                  onClick={() => setIsModifyEducation(false)}
                >
                  <i className="fa-solid fa-xmark text-lg"></i>
                </button>
              </div>
              {/* ModifyEducation component here */}
              <ModifyEducation
                selectedEducation={selectedEducation}
                saveEducationData={saveEducationData}
                fullEducationData={
                  educationArray.length > 0 ? educationArray.join("\n\n") : null
                }
                setEducationArray={setEducationArray}
                onCancel={() => setIsModifyEducation(false)}
              />
            </motion.div>
          )}
        </AnimatePresence>

        {/* Certification */}
        <AnimatePresence mode="wait">
          {!isModifyCertification ? (
            <motion.div
              key="certification-view"
              initial={{ x: 0, opacity: 1 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: "100%", opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="bg-white rounded-xl shadow p-6 relative"
            >
              <h2 className="text-xl font-bold mb-6">Certifications</h2>
              <button
                className="absolute top-6 right-6 text-gray-500 hover:text-black hover:bg-gray-200 focus:outline-none pt-0.5 pb-0.5 pl-2 pr-2 rounded-full transition"
                onClick={() => {
                  setSelectedCertification(null);
                  setIsModifyCertification(true);
                  setIsNewCertification(true);
                }}
                title="Add new certification"
              >
                <i className="fa-solid fa-plus text-lg"></i>
              </button>
              {certificationData.length > 0 ? (
                <ul className="list-none space-y-2">
                  {certificationData.map((cert, index) => (
                    <li
                      key={index}
                      className="cursor-pointer hover:bg-gray-100 p-2 rounded-md transition duration-200"
                      onClick={() => {
                        setSelectedCertification(cert);
                        setIsModifyCertification(true);
                        setIsNewCertification(false);
                      }}
                    >
                      <div className="flex items-start gap-4">
                        <div className="flex-1">
                          <p className="text-m font-medium text-gray-900">
                            {cert.certificationName}
                          </p>
                          <p className="text-xs text-gray-600 mt-1">
                            {cert.certificationDate}
                          </p>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm text-gray-500">No certification data!</p>
              )}
            </motion.div>
          ) : isNewCertification ? (
            <motion.div
              key="add-certification"
              initial={{ x: "-100%", opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: "-100%", opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="bg-white rounded-xl shadow p-6 relative"
            >
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold">Add New Certification</h2>
                <button
                  className="text-gray-500 hover:text-black hover:bg-gray-200 focus:outline-none pt-0.5 pb-0.5 pl-2 pr-2 rounded-full transition"
                  onClick={() => {
                    setSelectedCertification(null);
                    setIsModifyCertification(false);
                    setIsNewCertification(false);
                  }}
                >
                  <i className="fa-solid fa-xmark text-lg"></i>
                </button>
              </div>
              <AddCertificate
                expertID={id}
                getExpertCertifications={getExpertCertifications}
                onCancel={() => {
                  setIsModifyCertification(false);
                  setIsNewCertification(false);
                }}
              />
            </motion.div>
          ) : (
            <motion.div
              key="modify-certification"
              initial={{ x: "-100%", opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: "-100%", opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="bg-white rounded-xl shadow p-6 relative"
            >
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold">Modify Certification</h2>
                <button
                  className="text-gray-500 hover:text-black hover:bg-gray-200 focus:outline-none pt-0.5 pb-0.5 pl-2 pr-2 rounded-full transition"
                  onClick={() => setIsModifyCertification(false)}
                >
                  <i className="fa-solid fa-xmark text-lg"></i>
                </button>
              </div>
              <ModifyCertificate
                expertID={id}
                selectedCertification={selectedCertification}
                getExpertCertifications={getExpertCertifications}
                onCancel={() => setIsModifyCertification(false)}
              />
            </motion.div>
          )}
        </AnimatePresence>

        {/* Awards */}
        <AnimatePresence mode="wait">
          {!isModifyAward ? (
            <motion.div
              key="award-view"
              initial={{ x: 0, opacity: 1 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: "100%", opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="bg-white rounded-xl shadow p-6 relative"
            >
              <h2 className="text-xl font-bold mb-6">Awards</h2>
              <button
                className="absolute top-6 right-6 text-gray-500 hover:text-black hover:bg-gray-200 focus:outline-none pt-0.5 pb-0.5 pl-2 pr-2 rounded-full transition"
                onClick={() => {
                  setSelectedAward(null);
                  setIsModifyAward(true);
                  setIsNewAward(true);
                }}
                title="Add new award"
              >
                <i className="fa-solid fa-plus text-lg"></i>
              </button>
              {awardData.length > 0 ? (
                <ul className="list-none space-y-2">
                  {awardData.map((award, index) => (
                    <li
                      key={index}
                      className="cursor-pointer hover:bg-gray-100 p-2 rounded-md transition duration-200"
                      onClick={() => {
                        setSelectedAward(award);
                        setIsModifyAward(true);
                        setIsNewAward(false);
                      }}
                    >
                      <div className="flex items-start gap-4">
                        <div className="flex-1">
                          <p className="text-m font-medium text-gray-900">
                            {award.awardName}
                          </p>
                          <p className="text-xs text-gray-600 mt-1">
                            {award.awardDate}
                          </p>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm text-gray-500">
                  No award data available.
                </p>
              )}
            </motion.div>
          ) : isNewAward ? (
            <motion.div
              key="add-award"
              initial={{ x: "-100%", opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: "-100%", opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="bg-white rounded-xl shadow p-6 relative"
            >
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold">Add New Award</h2>
                <button
                  className="text-gray-500 hover:text-black hover:bg-gray-200 pt-0.5 pb-0.5 pl-2 pr-2 rounded-full"
                  onClick={() => {
                    setSelectedAward(null);
                    setIsModifyAward(false);
                    setIsNewAward(false);
                  }}
                >
                  <i className="fa-solid fa-xmark text-lg"></i>
                </button>
              </div>
              <AddAward
                expertID={id}
                getExpertAwards={getExpertAwards}
                onCancel={() => {
                  setIsModifyAward(false);
                  setIsNewAward(false);
                }}
              />
            </motion.div>
          ) : (
            <motion.div
              key="modify-award"
              initial={{ x: "-100%", opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: "-100%", opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="bg-white rounded-xl shadow p-6 relative"
            >
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold">Modify Award</h2>
                <button
                  className="text-gray-500 hover:text-black hover:bg-gray-200 pt-0.5 pb-0.5 pl-2 pr-2 rounded-full"
                  onClick={() => setIsModifyAward(false)}
                >
                  <i className="fa-solid fa-xmark text-lg"></i>
                </button>
              </div>
              <ModifyAward
                expertID={id}
                selectedAward={selectedAward}
                getExpertAwards={getExpertAwards}
                onCancel={() => setIsModifyAward(false)}
              />
            </motion.div>
          )}
        </AnimatePresence>

        {/* Additional */}
        <ExpertProjectInfo id={expertID} expertName={expertData?.name} />
      </section>

      {/* Sidebar */}
      <aside className="space-y-6">
        <Contact
          email={email}
          phoneNumber={phoneNumber}
          saveContactData={saveContactData}
        />
        <Rates
          hourlyRate={hourlyRate}
          hourlyCurrency={hourlyCurrency}
          dailyRate={dailyRate}
          dailyCurrency={dailyCurrency}
          saveRates={saveRateData}
        />
        <Availability
           availability={availability}
           availabilityComment={availabilityComment}
           saveAvailability={saveAvailabilityData}
        />
        <Info
          expertData={expertData}
          firstContactLog={firstContactLog}
          expertCity={city}
          expertRegion={region}
          expertCountry={country}
          languages={languages}
          exAvailability={availability}
          exAvailabilityComment={availabilityComment}
          saveInfo={saveInfoData}
          deleteLanguage={deleteLanguage}
          showStickyHeader={showStickyHeader}
        />
        <div className="bg-white rounded-xl shadow p-4">
          <h3 className="text-lg font-semibold mb-2">Note</h3>
          <Note expert_id={expertID} note={experienceData?.expertNote} />
        </div>
        <Skills expert_id={expertID} setHasSkill={setHasSkill} />
        <Industries expert_id={expertID} setHasIndustry={setHasIndustry} />

        <div className="relative bg-white rounded-xl shadow p-4">
          <ExpertSimilar expert_id={expertID} />
        </div>
      </aside>
    </>
  );
}
